import {
  Component,
  HostListener,
  Inject, Input, OnInit,
  PLATFORM_ID
} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {LOGIN_ROUTE, RECOVER_LOST_PASSWORD_ROUTE} from "src/app/app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {max_length_50, required} from '@utility';
import {ActionService, AuthenticationService} from "@services";
import {LoginRequest} from "@model";
import {isPlatformBrowser} from "@angular/common";
import {AbstractComponent} from "@components";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent extends AbstractComponent implements OnInit {
  @Input() eventId?: number;
  @Input() raceId?: number;

  loginComponentState: LoginComponentState = LoginComponentState.INITIAL;
  public currentWindowWidth: number = 0;
  private isBrowser: boolean;

  inputForm: FormGroup<{
    password: FormControl<string | null>;
    email: FormControl<string | null>;
    rememberMe: FormControl<boolean | null>
  }> = new FormGroup({
    email: new FormControl('', [
        required,
        max_length_50
      ]
    ),
    password: new FormControl('', [
      required,
    ]),
    rememberMe: new FormControl(false),
  });

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthenticationService,
              @Inject(PLATFORM_ID) private platformId: Object, private translocoService: TranslocoService,
              private actionService: ActionService) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.authService.logout(false);
      const loginData = this.authService.getLoginData();
      let user: string | undefined;
      let password: string | undefined;
      if (loginData) {
        [user, password] = loginData;
        this.inputForm.controls.rememberMe.setValue(true);
        this.inputForm.controls.email.setValue(user);
        this.inputForm.controls.password.setValue(password);
      }
    }
  }

  onSubmit(): void {
    if (!this.inputForm.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
    this.authService.login(new LoginRequest(this.inputForm.value.email, this.inputForm.value.password), () => {
      this.loginComponentState = LoginComponentState.ERROR;
    }, this.inputForm.controls.rememberMe.value);
    this.inputForm.reset();
  }

  goToRecoverPasswordPage(): void {
    this.router.navigate([RECOVER_LOST_PASSWORD_ROUTE]);
  }

  toLogin(): void {
    this.router.navigate([LOGIN_ROUTE]);
  }

  getLocale() {
    let activeLang = this.translocoService.getActiveLang();
    switch(activeLang){
      case 'hr':
        return 'hr';
      case 'en':
        return 'en';
      case 'it':
        return 'it';
      case 'slo':
        return 'sl';
      case 'sr':
        return 'sr-Latn';
      case 'bs':
        return 'sr-Latn';
      default:
        return 'en';
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.actionService.clearActions();
  }
}

enum LoginComponentState {
  INITIAL,
  ERROR,
}
